import {createInstance, useMatomo} from '@jonkoops/matomo-tracker-react';
import React, {useEffect} from 'react';
import * as Klaro from 'klaro';
import getKlaroConfig from './klaro';
import CookieLayer from '../components/partials/CookieLayer';

export const instance = createInstance({
    urlBase: 'https://veranstaltungen.dresden.de/analytics/matomo/',
    siteId: 1,
    configurations: (() => {
        const consentManager = Klaro.getManager(getKlaroConfig());
        const consents = consentManager.loadConsents();

        const config = {
            // Common config
            // setSecureCookie: true,
            setRequestMethod: 'POST',
        };

        // Depending on the users choices, tracking and cookies will be activated (or not)
        if (!consents.tracking) {
            config.requireConsent = true;
        }
        if (consents.tracking && !consents.cookies) {
            config.requireCookieConsent = true;
        }
        if (consents.tracking && consents.cookies) {
            config.requireConsent = true;
            config.setConsentGiven = true;
        }

        return config;
    })(),
});

export const MatomoListener = ({match, children}) => {
    const {trackPageView} = useMatomo();

    useEffect(() => {
        trackPageView();
    });

    return (
        <>
            <CookieLayer />
            {children({match})}
        </>
    );
};
